import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,  
  Label,
  Radio
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { settingsActions } from '../../actions/settings.actions';
import { userConstants } from '../../constants/user.constants';

class WebhookFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      webhook: {    
        url: '',
        authorizationHeader: '',
        name: '',
        enabled: true,        
        notifySettingsChanges: false,
        notifyUsersChanges: false,
        notifyAccessLogs: false,
        notifyClockRegisters: false,
        notifyNotifications: false,
        notifyRequests: false,
        notifyUserlock: false,
      },
      errors: {},
      submitted: false
    };    
  }

  componentDidMount() {
    const { match, dispatch, me } = this.props;    

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }
    
    if (match.params.id) {
        dispatch(settingsActions.getWebhook(match.params.id))
            .then(() => {                
                const webhook = _.mapKeys(this.props.webhook, function (v, k) { return k[0].toLowerCase() + k.substr(1); });                                                
                this.setState({ webhook })
            });
    }        
  }

  static get propTypes() { 
    return {       
        me: PropTypes.any,        
        user: PropTypes.any,
        loading: PropTypes.bool,        
        match: PropTypes.any
    }; 
  }

  handleChange(field, data) {        
    const { webhook } = this.state;    
    webhook[field] = data;    
    this.setState({ webhook });    
  }

  validate() {
    const { webhook } = this.state;
    
    let errors = {};
    let valid = true;

    if (!webhook.name || webhook.name.length == 0) {
      errors.name = "Preencha o nome";
      valid = false;
    }

    if (!webhook.url || webhook.url.length == 0) {
      errors.url = "Preencha a URL";
      valid = false;
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { webhook } = this.state;    

    const payload = webhook;
    if (webhook.id) {
        dispatch(settingsActions.updateWebhook(webhook.id, payload));
    } else {
        dispatch(settingsActions.createWebhook(payload));
    }
  }

  render() {    
    const { webhook, errors } = this.state;                
    
    return (  
      <Fragment>
      <h1>Webhook</h1>
      <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
        <Form.Input required error={errors.name} label='Nome' value={webhook.name} name='name' type='text' onChange={(e, data) => this.handleChange("name", data.value)} />
        { errors.name && <Label color='red'>{errors.name}</Label>}

        <Form.Input required error={errors.url} label='URL' value={webhook.url} name='url' type='text' onChange={(e, data) => this.handleChange("url", data.value)} />
        { errors.url && <Label color='red'>{errors.url}</Label>}

        <Form.Input>
            <Radio toggle checked={webhook.enabled} label='Habilitado' onChange={(e, data) => this.handleChange("enabled", data.checked)} />
        </Form.Input>

        <h3>Notificações</h3>
        <Form.Input>
            <Radio toggle checked={webhook.notifySettingsChanges} label='Alterações Configurações' onChange={(e, data) => this.handleChange("notifySettingsChanges", data.checked)} />            
        </Form.Input>
        <Form.Input>
            <Radio toggle checked={webhook.notifyUsersChanges} label='Alterações Usuários' onChange={(e, data) => this.handleChange("notifyUsersChanges", data.checked)} />            
        </Form.Input>
        <Form.Input>
            <Radio toggle checked={webhook.notifyRequests} label='Solicitações de Acesso' onChange={(e, data) => this.handleChange("notifyRequests", data.checked)} />            
        </Form.Input>
        <Form.Input>
            <Radio toggle checked={webhook.notifyClockRegisters} label='Registros de Ponto' onChange={(e, data) => this.handleChange("notifyClockRegisters", data.checked)} />            
        </Form.Input>
        <Form.Input>
            <Radio toggle checked={webhook.notifyAccessLogs} label='Eventos de Acesso Máquinas' onChange={(e, data) => this.handleChange("notifyAccessLogs", data.checked)} />            
        </Form.Input>
        <Form.Input>
            <Radio toggle checked={webhook.notifyUserlock} label='Eventos Userlock' onChange={(e, data) => this.handleChange("notifyUserlock", data.checked)} />            
        </Form.Input>

        <Button primary type='submit'>{webhook.id ? 'Alterar' : 'Criar'} Webhook</Button>
      </Form>
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { settings, users } = state;  
  let props = {
    me: users.me || null,        
    loading: settings.loading    
  };  

  if (settings && settings.webhook) {    
      var webhook = settings.webhook;      
      props.webhook = webhook;
  }  
  
  return props;
}

const connectedWebhookFormScreen = connect(mapStateToProps)(WebhookFormScreen);
export { connectedWebhookFormScreen as WebhookFormScreen };
